import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from './UserContext';

function AdminDashboard() {
    const { user } = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.rolle !== 'ADMIN') {
            navigate('/');
            return;
        }
    }, [user, navigate]);

    return (
        <div>
            <section className="hero-section py-12">
                <div className="container mx-auto px-4">
                    <h1>Admin Dashboard</h1>
                    <p className="lead">
                        Willkommen im Admin-Bereich. Hier können Sie alle Aspekte der Plattform verwalten und überwachen.
                    </p>
                </div>
            </section>

            <section className="page-content-section py-8">
                <div className="container mx-auto px-4">
                    <div className="max-w-6xl mx-auto">
                        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                            Verwaltungsoptionen
                        </h2>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-20">
                            {/* Öffentliche Liste */}
                            <div className="page-card">
                                <div className="flex items-center mb-4">
                                    <div className="text-3xl mr-4">📋</div>
                                    <h3>Öffentliche Liste</h3>
                                </div>
                                <p>
                                    Verwalten Sie alle öffentlich registrierten Firmen, deren Status und Informationen.
                                </p>
                                <button 
                                    onClick={() => navigate('/admin/public-list')} 
                                    className="btn btn-primary mt-4 w-full"
                                >
                                    Öffentliche Liste verwalten
                                </button>
                            </div>

                            {/* Private Firmen */}
                            <div className="page-card">
                                <div className="flex items-center mb-4">
                                    <div className="text-3xl mr-4">🔒</div>
                                    <h3>Private Firmen</h3>
                                </div>
                                <p>
                                    Verwalten Sie Ihre privaten Firmeneinträge und deren Bewerbungsstatus.
                                </p>
                                <button 
                                    onClick={() => navigate('/private-firmen')} 
                                    className="btn btn-primary mt-4 w-full"
                                >
                                    Private Liste öffnen
                                </button>
                            </div>

                            {/* Neue Private Firma */}
                            <div className="page-card">
                                <div className="flex items-center mb-4">
                                    <div className="text-3xl mr-4">➕</div>
                                    <h3>Neue Private Firma</h3>
                                </div>
                                <p>
                                    Erstellen Sie neue private Firmeneinträge für interne Verwaltungszwecke.
                                </p>
                                <button 
                                    onClick={() => navigate('/admin/create-private-firma')} 
                                    className="btn btn-primary mt-4 w-full"
                                >
                                    Private Firma erstellen
                                </button>
                            </div>
                        </div>
                        
                        {/* Quick Stats Section */}
                        <div className="mt-20 bg-white rounded-lg shadow-lg p-8">
                            <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">
                                Schnellübersicht
                            </h3>
                            
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div className="text-center p-4 bg-blue-50 rounded-lg">
                                    <div className="text-2xl font-bold text-blue-600 mb-2">📊</div>
                                    <h4 className="text-lg font-semibold text-gray-900">Statistiken</h4>
                                    <p className="text-gray-600 text-sm">
                                        Übersicht über alle Firmenanmeldungen und deren Status
                                    </p>
                                </div>
                                
                                <div className="text-center p-4 bg-green-50 rounded-lg">
                                    <div className="text-2xl font-bold text-green-600 mb-2">✅</div>
                                    <h4 className="text-lg font-semibold text-gray-900">Verwaltung</h4>
                                    <p className="text-gray-600 text-sm">
                                        Vollständige Kontrolle über alle Firmeneinträge
                                    </p>
                                </div>
                                
                                <div className="text-center p-4 bg-yellow-50 rounded-lg">
                                    <div className="text-2xl font-bold text-yellow-600 mb-2">⚡</div>
                                    <h4 className="text-lg font-semibold text-gray-900">Schnellzugriff</h4>
                                    <p className="text-gray-600 text-sm">
                                        Direkter Zugang zu allen wichtigen Funktionen
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="mt-16 bg-gray-50 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-gray-900 mb-4">Schnellaktionen</h4>
                            <div className="flex flex-wrap gap-3">
                                <button 
                                    onClick={() => navigate('/firmen-list')}
                                    className="btn btn-outline"
                                >
                                    Zur öffentlichen Firmenliste
                                </button>
                                <button 
                                    onClick={() => navigate('/')}
                                    className="btn btn-outline"
                                >
                                    Zur Startseite
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default AdminDashboard;